import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export function showCartToast(message) {
  toast.success(message, {
    position: 'bottom-right',
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored',
    style: {
      background: '#f5f3ea', // match your cardBg
      color: '#3b2f2f', // match your headingText
      borderRadius: '1rem',
      fontWeight: 600,
      fontFamily: 'inherit',
      boxShadow: '0 2px 12px 0 rgba(0,0,0,0.08)'
    },
    icon: '🛒',
  });
}

export function CartToastContainer() {
  return <ToastContainer newestOnTop />;
}
